import { LocalTimeRange, Uuid } from '@ftr/contracts/type/shared'
import { AccessLevel } from '@ftr/distribution-contracts'
import { LocalDate } from '@js-joda/core'

interface IdNamePair {
  id: Uuid
  name: string
}

// TODO - Cart items could include ongoing sessions, i.e. sessions without an end time.
// We should split sessionTime into separate required start and optional end time.
export interface CartItemModel {
  id: Uuid
  sessionId: Uuid
  courthouse: IdNamePair
  courtroom: IdNamePair
  recordingDate: string
  sessionTime: string
  requestedTimes: string[]
  accessLevel: AccessLevel
}

export interface CartItem {
  id: Uuid
  sessionId: Uuid
  courthouse: IdNamePair
  courtroom: IdNamePair
  recordingDate: LocalDate
  sessionTime: LocalTimeRange
  requestedTimes: LocalTimeRange[]
  accessLevel: AccessLevel
}

export interface CartGroup {
  key: string
  courthouse: IdNamePair
  courtroom: IdNamePair
  recordingDate: LocalDate
  items: CartItem[]
}

export interface CartStateModel {
  courtSystemId: Uuid | undefined
  cartItems: CartItemModel[]
}

export const CART_STATE_DEFAULT: CartStateModel = { courtSystemId: undefined, cartItems: [] }
